import { useParams } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import { useState } from "react";
import { useEffect } from "react";
import hbricon from "../otherImg/hrmwlitelogo.png";
import { getLastReadingPage, getSingleBook, initDB, saveLastReadingPage } from "../ConfigureIndexDB";
import { useRef } from "react";

const SavedBookReadPage=() => {
        const {id} = useParams();
        const regex = /\*\*/g;
        const [nightMode,setNightmode] = useState(false);
        const [books,setBookData]=useState(null);
        const [erroralert,setError]=useState(false);
        const [ispending,setPending]=useState(true);
        const [sharingError,setSharingerr]=useState(false);
        const parentRef = useRef();
        const audioRef = useRef();

        useEffect(()=>{
        initDB().then(()=>{
            getSingleBook(id).then((data)=>{
                if(data){
                    setBookData(data);
                    setPending(false);
                }
            }).catch((err)=>{
                console.log(err)
                setError(true);
                setPending(false);
            });
        }).catch((err)=>{
            console.log(err)
            setError(true);
            setPending(false);
        });
        },[id]);

        const handleScroll=(e)=>{
            const scrollTop = e.target.scrollTop;
            initDB().then(()=>{
                saveLastReadingPage({
                    id: `${books && books.id}`,
                    currentPage: scrollTop,
                    audioTime: books && books.audio && audioRef.current.currentTime
                }).catch((err)=>{
                    console.log(err);
                });
            }).catch((err)=>{
                console.log(err);
            });
        };

        useEffect(() => {
            initDB().then(()=>{
                getLastReadingPage(`${books && books.id}`)
                .then((data)=>{
                    if (data) {
                          const timeid = setTimeout(() => {
                            try{
                                parentRef.current.scrollTop = data.currentPage;
                                if(data.audioTime){
                                    audioRef.current.currentTime = data.audioTime;
                                }
                            }catch(err){
                                console.log(err);
                            }
                             
                            }, 3000);
                            return () => clearTimeout(timeid);
                    }
                }).catch((err)=>{
                    console.log(err);
                });
            }).catch((err)=>{
                console.log(err);
            });
          }, [books]);

        const shareBlogPost=async()=>{
            if(navigator.share){
                try{
                    await navigator.share({
                        title: `${books && books.title}`,
                        text: `Check out this book and your life will never be the same. Very inspiring and crucial for our eternal life.`,
                        url: `https://horemowbookreaderlite.web.app/hrmwenglishbooks/${books && books.title}/${books && books.id}`,
                    });
                }catch(error){
                  
                }
            }else{
                setSharingerr(true);
            }
        }; 
    


    return (  
        <div className={`readingpage ${nightMode? 'nightmode':'normal'}`}>
            {erroralert && <div><h2>Oops something went wrong ... Try to refresh or report issue</h2></div>}
            {ispending && <div style={{position:"fixed",top:"30%",left:"40%"}}> 
            <CircularProgress color="secondary"/> <br/>
            Preparing Book...
            </div>} 

            <div className={`readingpagetop ${nightMode? 'nightmode':'normal'}`}>
                    
                        {books && books.audio && 
                        <div className="content-audio">
                        <audio src={books.audio} controls ref={audioRef}/>
                        <p style={{color: "black"}}>Listen to Audio</p>
                        </div>
                        }

                        <div className="readingpagetopmenus flex-row2">
                            {!ispending && !nightMode && 
                            <div className="togglenight" onClick={()=>setNightmode(prev => !prev)}>
                                    <svg
                                    viewBox="0 0 24 24"
                                    fill="#121212"
                                    height="2em"
                                    width="2em">
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z" />
                                    </svg>
                                    <h3 style={{color:"white"}}>Night Light</h3>
                            </div>
                            }

                            {nightMode && 
                            <div className="toggleday" onClick={()=>setNightmode(prev => !prev)}>
                            <svg
                            viewBox="0 0 24 24"
                            fill="white"
                            height="2em"
                            width="2em">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M11 4V2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1zm7.36 3.05l1.41-1.42a.996.996 0 10-1.41-1.41l-1.41 1.42a.996.996 0 101.41 1.41zM22 11h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm-10 8c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zM5.64 7.05L4.22 5.64c-.39-.39-.39-1.03 0-1.41s1.03-.39 1.41 0l1.41 1.41c.39.39.39 1.03 0 1.41s-1.02.39-1.4 0zm11.31 9.9a.996.996 0 000 1.41l1.41 1.41c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm3.64 6.78l1.41-1.41c.39-.39.39-1.03 0-1.41s-1.03-.39-1.41 0l-1.41 1.41a.996.996 0 000 1.41c.38.39 1.02.39 1.41 0zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z" />
                            </svg>
                                <h3>Day Light</h3>
                            </div>
                            }

                            <div className="sharesavedbook flex-row2"  onClick={()=>shareBlogPost()}>
                            <h3>Share</h3>
                            <svg
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                height="2em"
                                width="2em">
                                <path d="M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 006 9c-1.654 0-3 1.346-3 3z" />
                                </svg>
                                
                            </div>
                            
                        </div>

                    <div className="pagetoplogo flex-row2">
                        <h3>HbrSoftTeam</h3>
                        <img src={hbricon} alt=""/>
                    </div>

            </div>

            <div className={`readingpagetop-phone ${nightMode? 'nightmode':'normal'}`}>
                    
                    {books && books.audio && 
                    <div className="content-audio">
                    <audio src={books.audio} controls ref={audioRef}/>
                    <p style={{color: "black"}}>Listen to Audio</p>
                    </div>
                    }

                    <div className="readingpagetopmenus flex-row2">
                        {!ispending && !nightMode && 
                        <div className="togglenight" onClick={()=>setNightmode(prev => !prev)}>
                                <svg
                                viewBox="0 0 24 24"
                                fill="#121212"
                                height="2em"
                                width="2em">
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path d="M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z" />
                                </svg>
                                <h3 style={{color:"white"}}>Night Light</h3>
                        </div>
                        }

                        {nightMode && 
                        <div className="toggleday" onClick={()=>setNightmode(prev => !prev)}>
                        <svg
                        viewBox="0 0 24 24"
                        fill="white"
                        height="2em"
                        width="2em">
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M11 4V2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1zm7.36 3.05l1.41-1.42a.996.996 0 10-1.41-1.41l-1.41 1.42a.996.996 0 101.41 1.41zM22 11h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm-10 8c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zM5.64 7.05L4.22 5.64c-.39-.39-.39-1.03 0-1.41s1.03-.39 1.41 0l1.41 1.41c.39.39.39 1.03 0 1.41s-1.02.39-1.4 0zm11.31 9.9a.996.996 0 000 1.41l1.41 1.41c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm3.64 6.78l1.41-1.41c.39-.39.39-1.03 0-1.41s-1.03-.39-1.41 0l-1.41 1.41a.996.996 0 000 1.41c.38.39 1.02.39 1.41 0zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z" />
                        </svg>
                            <h3>Day</h3>
                        </div>
                        }

                        <div className="sharesavedbook flex-row2"  onClick={()=>shareBlogPost()}>
                        <svg
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            height="2em"
                            width="2em">
                            <path d="M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 006 9c-1.654 0-3 1.346-3 3z" />
                            </svg>
                            
                        </div>
                        
                    </div>
          </div>

            {sharingError && 
           <div className="toast2">
           <p style={{color:"white",fontWeight:"bold"}}>
           Browser not supported for sharing book, Try using modern chrome or 
           Safari or Edge browser or simply click to open the book, 
           copy the link of the selected book from the address bar and share
          </p> 
             <svg
             cursor="pointer"
             onClick={()=>setSharingerr(false)}
             viewBox="0 0 24 24"
             fill="white"
             height="30px"
             width="30px">
             <path fill="none" d="M0 0h24v24H0z" />
             <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
             </svg>
         </div>
         }

            {books && (
            <div className={`reading-layout ${nightMode? 'nightmode':'normal'}`}
            onScroll={handleScroll} ref={parentRef}>
                    <article>
                        <h2>{books.title}</h2>
                        <h3>Written by {books.author}</h3>
                        <img src={books.image} alt="book cover"></img>
                        <pre>{books.body && books.body.replace(regex,"")}</pre>
                    </article>
                    </div>
                )}

  </div>
    );
}
 
export default SavedBookReadPage;